import Message from '@sats-group/ui-lib/react/message';
import React, { useEffect, useRef } from 'react';
import useMessage from '~/client/hooks/use-message';
import ContentContainer from '../content-container/content-container';
import type { DynamicMessage as Props } from './dynamic-message.types';

const DynamicMessage: React.FunctionComponent<Props> = ({ closeText }) => {
  const timerRef = useRef<number>(null);
  const [message, clearMessage] = useMessage();

  useEffect(() => {
    if (message && message.theme === 'success') {
      timerRef.current = Number(setTimeout(clearMessage, 10000));
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [message]);

  // NOTE: Always make sure that the live region is present in the document first,
  // and only then dynamically add/change any content.
  // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
  return (
    <ContentContainer aria-live="polite" className="dynamic-message">
      {message ? (
        <Message
          action={{
            elementName: 'button',
            onClick: clearMessage,
            text: closeText,
          }}
          {...message}
        />
      ) : null}
    </ContentContainer>
  );
};

export default DynamicMessage;
